import { IHttpAdapter } from '../../entity/interface/iHttpAdapter';
import { IApiPathManager } from '../config/ApiPathManager';
import { container } from '../../DataDomain';
import { DI } from '@intigral/constant/config/DIContainer';
import { IPaymentConfigRepository } from '../../core/repositories/interfaces/iPaymentConfig';
import { API_IDS } from '@intigral/constant';
import { IPaymentConfigEntity } from '../../entity/interface/iPaymentConfig';

class PaymentConfigRepository implements IPaymentConfigRepository {
    // Lazy getters for dependencies to avoid circular dependencies
    private get http(): IHttpAdapter {
        return container.resolve<IHttpAdapter>(DI.UTILS.IHttpAdapter);
    }

    private get apiPathManager(): IApiPathManager {
        return container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async getPaymentConfig(): Promise<IPaymentConfigEntity> {
        const paymentConfigresponse = await this.http.get(this.apiPathManager.getPath(API_IDS.CONFIG_PAYMENT_CONFIG), {
            params: {
                appKey: process.env['NX_PUBLIC_APP_KEY'],
                productKey: process.env['NX_PUBLIC_PRODUCT_KEY'],
            },
        });
        const paymentConfig: IPaymentConfigEntity = paymentConfigresponse?.data as IPaymentConfigEntity;
        return paymentConfig;
    }
}

export default PaymentConfigRepository;
